
  import { Component, Vue } from 'vue-property-decorator';
  import VueCookies from 'vue-cookies';
  import { mapGetters } from 'vuex';

  import Information from '@/components/Account/Information.vue';
  import Newsletter from '@/components/Account/Newsletter.vue';

  import errorsService from '@/services/errors.service';
  import routeService from '@/services/route.service';
  import accountService from '../../services/account.service';
  import { IConfirmEmailModel } from '../../models/account.model';

  Vue.use(VueCookies);

  @Component({
    components: {
      Information,
      Newsletter
    },
    computed: {
      ...mapGetters([
        'user',
        'token',
        'isLoading',
        'redirectUrl'
      ])
    }
  })
  export default class ConfirmEmail extends Vue {
    created() {
      if (this.$route.query.uid == null) {
        errorsService.handleErrors(this, null, 400);
      }
      else {
        this.$store.dispatch("updateIsLoading", true);

        const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "email/confirm";

        accountService.post<IConfirmEmailModel, object>(this, url, { Uid: this.$route.query.uid.toString() })
          .then(() => {
            this.$store.dispatch("updateIsLoading", false);
            routeService.redirectToLogin(this, this.$route.query.redirectUrl as string);
          })
          .catch(error => {
            this.$store.dispatch("updateIsLoading", false);
            errorsService.handleErrors(this, error);
          });
      }
    }
  }

